import React from "react";
import ReactSelect, {Props} from "react-select";

type SelectProps = {
} & Props;

const Select : React.FC<SelectProps> = ({className, ...props}) =>
    <ReactSelect className={"jobjump-form-select "+className} {...props} />

export default Select;